import rrssb from 'rrssb/js/rrssb.min';

jQuery(document).ready(function ($) {

    $('.rrssb-buttons').rrssb()

    // JS Breakpoints
    var isBreakPoint = function (bp) {
        var bps = [0, 1000, 3500],
                w = $(window).width(),
                min, max
        for (var i = 0, l = bps.length; i < l; i++) {
            if (bps[i] === bp) {
                min = bps[i - 1] || 0
                max = bps[i]
                break
            }
        }
        return w > min && w <= max
    }

    if (isBreakPoint(1000)) {
        $('.sidebar__button--share').on('click', function () {
            $('.sidebar__rrssb').toggleClass('sidebar__rrssb--show');
        });
    }

});
